import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import * as moment from "moment";
import { AdminService } from '../admin.service';
import { EditRmsBidComponent } from "./edit-rms-bid/edit-rms-bid.component";
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'app-procure',
    templateUrl: './procure.component.html',
    styleUrls: ['./procure.component.scss']
  })
  
export class ProcureComponent implements OnInit {

    public materialList: any;
    public moment: any;   
    public tab_index: number;
    public userID: any; 
    isRMS: boolean;
    quoteCount: any;
    bidCount: any;
    supplierOrderCount: any;
    partnerOrderCount: any;
    supplierOrderList: any;
    partnerOrderList: any;

    constructor(
      public adminService: AdminService,
      public router: Router,
      public dialog: MatDialog
    ){

    }

    ngOnInit(): void {
      this.userID = localStorage.getItem('id');
      this.moment = moment;
      this.tab_index = 0;
      if(localStorage.getItem('isRMS') != 'undefined' && localStorage.getItem('isRMS') != 'false'){
        this.getQuotesBid(this.userID);
        this.getSupplierOrdersCount();
        this.isRMS = false;
      } else {
        this.getQuotes(this.userID);
        this.getPartnerOrdersCount();
        this.isRMS = true;
      } 
    }

    public getQuotes(userId): void{
      this.adminService.getQuotesList(userId).subscribe(
        (res: any) => {
            this.materialList = res.body?.data;
            this.quoteCount = this.materialList?.length
        },
        err => {
          console.log(err)
        }
      );
    }

    public getQuotesBid(userId): void{
      this.adminService.getQuotesBidList(userId).subscribe(
        (res: any) => {
            this.materialList = res.body?.data;
            this.bidCount = this.materialList?.length;
        },
        err => {
          console.log(err)
        }
      );
    }

    public getSupplierOrders(): void{
      this.adminService.getSupplierOrderList(this.userID).subscribe(
          (res: any) => {
              this.materialList = res.body?.data;
              this.supplierOrderCount = this.materialList?.length;
          },
          err => {
            console.log(err)
          }
        );
    }

    public getSupplierOrdersCount(): void{
      this.adminService.getSupplierOrderList(this.userID).subscribe(
          (res: any) => {
              this.supplierOrderList = res.body?.data;
              this.supplierOrderCount = this.supplierOrderList?.length;
          },
          err => {
            console.log(err)
          }
        );
    }

    public getPartnerOrders(): void{
      this.adminService.getPartnerOrderList(this.userID).subscribe(
          (res: any) => {
              this.materialList = res.body?.data;
              this.partnerOrderCount = this.materialList?.length;
          },
          err => {
            console.log(err)
          }
        );
    }

    public getPartnerOrdersCount(): void{
      this.adminService.getPartnerOrderList(this.userID).subscribe(
          (res: any) => {
              this.partnerOrderList = res.body?.data;
              this.partnerOrderCount = this.partnerOrderList?.length;
          },
          err => {
            console.log(err)
          }
        );
    }

    tabChange(event): void {
      this.tab_index = event.index;
      if(event.index === 0){
        if(localStorage.getItem('isRMS') != 'undefined' && localStorage.getItem('isRMS') != 'false'){
          this.getQuotesBid(this.userID);
        } else {
          this.getQuotes(this.userID);
        }
      }else{
        if(localStorage.getItem('isRMS') != 'undefined' && localStorage.getItem('isRMS') != 'false'){
          this.getSupplierOrders();
        } else {
          this.getPartnerOrders();
        }
      }
    }

    editPage(list): void{
      if(this.tab_index === 0 && this.isRMS == true){
        this.router.navigate(['/admin/procure/edit-quote', list.id]);
      } else if (this.tab_index === 0 && this.isRMS == false){
        this.router.navigate(['/admin/procure/edit-bid', list.id, list.quoteorderid, list.bidItems.length]);
      } else {
        this.router.navigate(['/admin/procure/view-order', list.id]);
      }
    }

    editPopUp(list){
      const dialogRef = this.dialog.open(EditRmsBidComponent,{
        width: '1000px',disableClose: true ,
        data : { data: list}
      });
    }
}